import { render, staticRenderFns } from "./noRecord.vue?vue&type=template&id=7fe1e5d8&scoped=true&"
import script from "./noRecord.vue?vue&type=script&lang=js&"
export * from "./noRecord.vue?vue&type=script&lang=js&"
import style0 from "./noRecord.vue?vue&type=style&index=0&id=7fe1e5d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe1e5d8",
  null
  
)

export default component.exports